<template>
  <div>
    <div class="d-flex height-set-for-component">
      <table
                class="tabletable-with-border table-responsive table-scroll small-first-col table-cell-styles" style="background: transparent;width:93%;margin:15px !important;">
        <thead style="color: #eee">
          <tr style="height:40px;">
            <th scope="col" class="text-left" style="width:40%;">
              {{$t('Path')}}
            </th>
            <th scope="col" class="text-center" style="width:30%;">
              {{$t('Permission')}}
            </th>
            <th scope="col" class="text-center" style="width:20%;">
              {{$t('Recursive folder permission')}}
            </th>
            <th scope="col" class="text-center" style="width:10%;"></th>
          </tr>
        </thead>
        <tbody class="body-half-screen">

          <tr v-if="addNewRow" :key="newRowDetails.path">
            <td class="text-left col-md-6" >
              <folder-multiselect :allowSingleSelect="true" ref="newPath" :enableCatBrowser="true"
               @updatedCatalogsList="handleCatalogSelection" :enableMultiSelect="false"
                :setDefaultFocus="true"></folder-multiselect>
            </td>
            <td class="text-center col-md-3">
              <Multiselect
              :value="newRowPerm.label"
              :options="permissionTypes"
              :searchable="false"
              :close-on-select="true"
              :allow-empty="false"
              :label="label"
              deselectLabel=""
              selectLabel=""
              selectedLabel=""
              :ref="newRowDetails.path"
              @select="editNewRowPermission($event)"
              @open="decideOpenDirection($event,newRowDetails)"
              :appendToBody="true"
              :openDirection="dropdownOpenDirection"
              :track-by="type">
              <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
              <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
              </div>
              <span slot="noResult">No results.</span>
              </Multiselect>
            </td>
            <td class="text-center col-md-2">
              <div
              class="custom-control custom-switch category-div"
              >
              <input
                v-model="newRowDetails.apply_recursively"
                :id="newRowDetails._id"
                type="checkbox"
                class="custom-control-input"
              />
              <label
                class="custom-control-label category-label"
                :for="newRowDetails._id"
                >
                <div class="category-head" v-if="newRowDetails.apply_recursively">{{$t('Enabled')}}</div>
                <div class="category-head" v-else>{{$t('Disabled')}}</div>
              </label>
            </div>
            </td>
            <td class="col-md-1">
              <svg
                v-on:click="deleteNewRowPermission()"
                width="2em"
                height="1.5em"
                viewBox="0 0 16 16"
                class="bi bi-trash delete-btn"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                />
                <path
                  fill-rule="evenodd"
                  d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                />
              </svg>
            </td>
          </tr>
            <tr v-for="(key,index) in catalogPermissions" :key="key.path">
            <td class="text-left col-md-6">
              <span v-if="Object.keys(key).includes('name_path')" class="display-name-path">{{ key.name_path }}</span>
              <span v-else class="display-name-path">{{getPathNameOfFolder(key.path)}}</span>
            </td>
            <td class="text-center col-md-3">
              <Multiselect
              :value="mapPermissionTypwWithLabel[key.access_right]"
              :options="permissionTypes"
              :searchable="false"
              :close-on-select="true"
              :allow-empty="false"
              @select="editTheUserGroupPermission($event,key)"
              :label="label"
              deselectLabel=""
              selectLabel=""
              selectedLabel=""
              :ref="key.path"
              :track-by="type"
              @open="decideOpenDirection($event,key)"
              :appendToBody="true"
              :openDirection="dropdownOpenDirection">
              <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
              <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
              </div>
              <span slot="noResult">No results.</span>
              </Multiselect>
            </td>
            <td class="text-center col-md-2">
              <div
                class="custom-control custom-switch category-div"
                >
                <input
                  v-model="key.apply_recursively"
                  @change="updateRecursivePermission(key, $event)"
                  :id="key._id"
                  type="checkbox"
                  class="custom-control-input"
                />
                <label
                  class="custom-control-label category-label"
                  :for="key._id"
                  >
                  <div class="category-head" v-if="key.apply_recursively">{{$t('Enabled')}}</div>
                  <div class="category-head" v-else>{{$t('Disabled')}}</div>
                </label>
              </div>
            </td>
            <td class="col-md-1">
              <svg
                v-on:click="deleteCatalogPermissions(index)"
                width="2em"
                height="1.5em"
                viewBox="0 0 16 16"
                class="bi bi-trash delete-btn"
                fill="currentColor"
                style="position: relative;top: 8px;"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                />
                <path
                  fill-rule="evenodd"
                  d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                />
              </svg>
            </td>
          </tr>
        </tbody>
      </table>
      <div>
        <svg
          width="2em"
          height="2em"
          viewBox="0 0 16 16"
          class="bi bi-plus-square mt-4"
          fill="currentColor"
          @click="enableNewRow()"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M14 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
          />
          <path
            fill-rule="evenodd"
            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
          />
        </svg>
      </div>
    </div>
  </div>
</template>


<script>
import FolderAutoComplete from "../categories/CatalogMultiselectDropdown.vue";
import Constants from "../../components.constants.js";
import {mapMutations,mapActions} from "vuex";
import Utils from "../../components.utils.js";
import {NotifierConstants} from "../../components.constants.js";
import Multiselect from 'vue-multiselect';

export default {
  props: ["selectedUserGroupID","newUserGroup", "selectedUserGroupInfo"],
    data() {
      return {
        newRowDetails:{
          access_right:"full-control",
          apply_recursively:false,
          name_path:"",
          path:"",
          _id:"new"
        },
        newRowPerm:{label:"FULL CONTROL",type:"full-control"},
        addNewRow:false,
        catalogPermissions: [],
        showDropdown: false,
        routes:[],
        permissionTypes:[
          {label:"FULL CONTROL",type:"full-control"},
          {label:"READ MODIFY",type:"read-modify"},
          {label:"READ WRITE",type:"read-write"},
          {label:"READ ONLY",type:"read"},
          {label:"BROWSE", type:"browse"},
          {label:"NO ACCESS",type:"no-access"},
        ],
        mapPermissionTypwWithLabel:{
        "read":"READ ONLY",
        "read-write":"READ WRITE",
        "full-control":"FULL CONTROL",
        "no-access":"NO ACCESS",
        "browse":"BROWSE",
        "read-modify":"READ MODIFY",
        },
        displayIdNameMapper:{},
        dropdownOpenDirection:"below",
        browseWorkspaceList:[Constants.WORKSPACE_CATALOG],
      };
    },
    methods: {
      enableNewRow(){
        if(this.addNewRow){
          alert("New row is already added.")
        }
        this.addNewRow = true
        this.$refs.newPath.focus()
      },
      resetNewRow(){
        this.addNewRow = false;
        this.newRowDetails = {
          access_right:"full-control",
          apply_recursively:false,
          name_path:"",
          path:""
        }
      },
      deleteNewRowPermission(){
        if(this.addNewRow){
          this.resetNewRow()
        }
      },
      handleCatalogSelection(catPath){
        let browsedCatalogs = [catPath]
        if(Array.isArray(catPath)){
          browsedCatalogs = catPath
        }
        let pathInfoList = []
        for(let eachCat of browsedCatalogs){
          pathInfoList.push({"access_right":this.newRowPerm['type'],
           "path":eachCat.parent_id_path[0] + "/"+eachCat._id,
           "apply_recursively":this.newRowDetails['apply_recursively']})
          let parentPathInfo = eachCat["parent_path"][0];
          let parentPath = parentPathInfo.value;
          parentPath = parentPath.replace("catalog://0/","")
          this.displayIdNameMapper[eachCat._id] = parentPath + "/" + eachCat.catalog_name;
        }
        if(pathInfoList){
          this.updateUserCatalogPermissions("add",pathInfoList)
        }
      },
      updateUserCatalogPermissions(type,catPathList,event){
        let permissionList = this.catalogPermissions
        if(type == "add"){
          for(let catPath of catPathList){
            let removeDuplicateBin = this.catalogPermissions.filter((val)=>val.path==catPath.path);
            if(removeDuplicateBin.length != 0){
                this.$toast.error(`Selected path "${catPath.path}" is already added.`);
                return;
            }else{
              permissionList.unshift(catPath);
            }
          }
        }else{
          for (let catPermission of permissionList) {
              if(catPermission.path == catPathList[0].path){
                catPermission.access_right = event.type;
              }
          }
        }
        if(this.newUserGroup){
          this.catalogPermissions = permissionList
          this.resetNewRow()
          return
        }
        let payload = {};
        payload.access_control = {catalogs:permissionList}
        payload.params = { _id: this.selectedUserGroupID };
        this.updateExistingUserGroup(payload).then((data)=>{
          this.resetNewRow()
          if (data.statusCode==200){
            this.catalogPermissions = permissionList
            this.$toast.success(data.message);
          }else{
            this.$toast.error(data.message);
          }
        });
      },
      editNewRowPermission(e){
        this.newRowPerm = e
        this.newRowDetails.access_right = e.type
      },
      editTheUserGroupPermission(e,key){
        this.updateUserGroupCatalogPermissions('edit',[key],e)
      },
      getCategoryRoutefromId(categoryId){
        let info = this.routes.filter((info)=>Object.keys(info).includes(categoryId))
        if (info.length == 0){
          return ""
        }
        return info[0][categoryId]
      },
      updateRoute(categoryId){
        if(Object.keys(categoryId).includes("parent_id_path") && categoryId.parent_id_path.length <= 0){
            return
        }
        let info = {}
        info[categoryId._id] = categoryId.parent_id_path
        this.routes.push(info)
      },
      refreshCatalogPermissionTable(){
        if(this.newUserGroup){
          return
        }
          if(typeof(this.selectedUserGroupID) != "undefined"){
              if(this.selectedUserGroupInfo){
                this.catalogPermissions = this.selectedUserGroupInfo.access_control.catalogs;
                for (let category of this.catalogPermissions) {
                  this.updateRoute(category)
                }
            }
          }
      },
      getUserGroupCatalogPermissions(){
        return this.catalogPermissions
      },
      updateRecursivePermission(key, e){
        this.updateUserGroupCatalogPermissions('rec-permission',[key],e)
      },
      deleteCatalogPermissions(rowIndex){
          if (confirm(`Are you sure you want to delete the selected catalog permission ?`)) {
            let permissionList = this.catalogPermissions
            permissionList.splice(rowIndex, 1)
            if(this.newUserGroup){
              this.catalogPermissions = permissionList;
              return;
            }
            let payload = {};
            payload.access_control = {catalogs:permissionList}
            payload.params = { _id: this.selectedUserGroupID };
            this.updateExistingUserGroup(payload).then((data)=>{
                if (data.statusCode==200){
                    this.catalogPermissions = permissionList
                    this.$toast.success(data.message);
                }else{
                    this.$toast.error(data.message);
                }
           });
          }
      },
      updateUserGroupCatalogPermissions(type,catPathList,event){  
        let permissionList = this.catalogPermissions
        if(type == "add"){
          for(let catPath of catPathList){
            let removeDuplicateBin = this.catalogPermissios.filter((val)=>val.path==catPath.path);
            if(removeDuplicateBin.length != 0){
                this.$toast.error(`Selected path "${catPath.path}" is already added.`);
                return;
            }else{
              permissionList.unshift(catPath);
            }
          }
        }else{
          if(!["rec-permission"].includes(type)){
            for (let catPermission of permissionList) {
                if(catPermission.path == catPathList[0].path){
                    catPermission.access_right = event.type;
                }
            }
          }
        }
        this.resetNewRow()
        if(this.newUserGroup){
          this.catalogPermissions = permissionList
          return
        }
        let payload = {};
        payload.access_control = {catalogs:permissionList}
        payload.params = { _id: this.selectedUserGroupID };
        this.updateExistingUserGroup(payload).then((data) => {
            if (Utils.isAcceptedStatusCode(data.statusCode)) {
                if (data.message.includes("Failed")) {
                    this.$toast.warning(data.message);
                } else {
                    this.catalogPermissions = permissionList
                    this.$toast.success(data.message);
                }
            } else {
                this.$toast.error(data.message);
            }
        });
     },
     getPathNameOfFolder(folderIdPath){
      let pathList = folderIdPath.split("/");
      let folderId = pathList[pathList.length - 1]
      return this.displayIdNameMapper[folderId];
    },
    decideOpenDirection(e,key){
      this.$nextTick(()=>{
        let divRef = this.$refs[key.path][0].$el.getBoundingClientRect();
        if(divRef.y > 410){
          this.dropdownOpenDirection = "above";
        }else{
          this.dropdownOpenDirection = "below";
        }
      })
    },
    handleUsersGroupNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let user_group_info = notification.message
        if (user_group_info._id == this.selectedUserGroupID){
          this.catalogPermissions = user_group_info.access_control.catalogs;
          for (let category of this.catalogPermissions) {
            this.updateRoute(category.path)
          }
        }
      }
    },
    registerforWebsocketNotifications(){
      this.addWSEventListener({
            eventname:[ NotifierConstants.userGroupModifiedNotification],
            callback:this.handleUsersGroupNotification,
            parent:"CatalogPermissions"})
    },
    unRegisterforWebsocketNotifications(){
      this.removeWSEventListener({
            eventname:[ NotifierConstants.userGroupModifiedNotification],
            callback:this.handleUsersGroupNotification,
            parent:"CatalogPermissions"})
    },
    ...mapActions("assets",["getCategoryTreefromId"]),
    ...mapActions("userGroups",["getUserGroupInfoFromServer","updateExistingUserGroup"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"])
    },
    beforeDestroy(){
      this.unRegisterforWebsocketNotifications()
    },
    created(){ 
      this.registerforWebsocketNotifications();
      this.refreshCatalogPermissionTable();
      },
    components: {
      "folder-multiselect": FolderAutoComplete,
      "Multiselect":Multiselect
    },
};

</script>


<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;

.showmodal {
  display: block;
}

.table-scroll {
    /*width:100%; */
    /* Decoration */
    border-spacing: 0;
    margin: 0px 15px;
    border: $secondary-border-color !important;
        thead {
            color: $dull-text-color !important;
            position: relative;
            width: 100%;
            border: $secondary-border-color !important;
            th {
            position: sticky;
            top: -1px;
            background: $primary-background;
            z-index: 9;
            }
        }
        tbody {
            width: 100%;
            overflow: auto;
            font-weight: 500;
            tr {
            height: 60px;
            }
            tr:hover{
                background: $bg-color-on-hover !important;
            }
        }
    }


    .table {
        th {
            border-top: none !important;
            padding:0 10px !important;
        }
        td {
            border-top: none !important;
            padding:0 1rem!important;
        }
    }

    th {
        border-top: none !important;
        padding:0 10px !important;
    }

    .table-cell-styles{
        td{
            padding:0 10px !important;
        }
    }

    .table-with-border {
        thead {
            border-bottom: $border-color;
        }
        tr {
            border-bottom: $border-color;
        }
    }


svg {
  color: #666666;
}

svg:hover {
  color: $text-color;
}

.delete-btn {
  visibility: hidden;
}
.body-half-screen tr:hover .delete-btn {
  visibility: visible;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.height-set-for-component {
  height: calc(100vh - 130px);
  overflow: auto;
}

::v-deep{
  .multiselect{
        width:87% !important;
  }
  .multiselect__content-wrapper{
    display:none;
  }
  .multiselect__tag {
      background-color: $primary-background !important;
    }
    .multiselect__tags{
        background: $primary-background;
        border: $border-color !important;
    }
    .multiselect__option--highlight {
        background: $bg-color-on-hover !important;
    }
    .multiselect__content {
        background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__tag-icon{
       color:$text-color !important;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover !important;
        color: $text-color !important;
    }
    .multiselect__tag-icon:after{
       color:$secondary-text-color !important;
       font-size: 23px;
    }
    .multiselect *{
        font-size: $input-field-and-label-font-size !important;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect{
      color:$text-color !important;
      font-size: $input-field-and-label-font-size !important;
      width:70%;
      margin: 0;
      min-height: 38px;
      height: 38px;
    }
    .multiselect__option--selected{
        background: $bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
            // border: 1px solid #292828 !important;
            border: $border-color !important;
            display: block;
            background: $secondary-background-color;
            width: 100%;
            max-height: 245px !important;
            overflow: auto;
            border: $border-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
    .multiselect--above .multiselect__content-wrapper{
       background: $secondary-background-color!important;
    }
    .multiselect__tags {
        background: transparent !important;
    }
    .multiselect__content-wrapper::-webkit-scrollbar {
     width: 8px;
    }

    .multiselect__content-wrapper::-webkit-scrollbar-track {
      background: #22272b !important;
    }

    .multiselect__content-wrapper::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb-background !important;
    }

    .multiselect__content-wrapper::-webkit-scrollbar-thumb:hover {
      background: $scrollbar-thumb-on-hover-background;
    }
}

.custom-control-input{
  z-index:999;
}

.custom-control-label::before {
  background-color: $primary-background;
}

.category-div {
    margin-inline-start: 6%;
    margin: 25px 14%;
    width: 86%;
}

.category-label {
  padding-top: 2px;
  font-weight: 600;
  display: block !important;
}
.category-head {
    float: inline-start;
    text-align: initial;
    width: 100%;
}
.display-name-path {
  word-break: break-all;
  width: 100%;
  display: inline-block;
}
</style>
